import GenericDB from './generic-db';

export default class ClientAuthorizationsDB extends GenericDB {
  constructor() {
    super('clientAuthorizations');
  }
}
